<template>
    <div class="px-3 flex-1 flex">
        <div class="bg-[#f5f4f9] max-w-[1331px] w-full mx-auto rounded-[20px] overflow-hidden pt-10 pb-16 flex-1 flex items-center justify-center px-3">
            <div class="max-w-[1108px] w-full mx-auto">
                <div class="bg-white rounded-[15px] sm:col-span-2 col-span-4 md:col-span-1 xl:col-span-2 overflow-hidden order-3 xl:order-1 mb-5">
                    <div class="border-b border-[#eeeff2] py-3 px-5 gap-2 flex flex-wrap items-center justify-between">
                        <div class="flex items-center gap-5">
                            <img src="@/../img/icons/settings.svg" alt="">
                            <span class="block text-[20px] md:text-[25px] font-[CircularBold]">Account Page</span>
                        </div>
                        <button
                            class="max-w-[150px] w-full flex items-center justify-center gap-3 bg-[#366fed] hover:bg-[#5282eb] rounded-[5px] px-2 py-[.35em] md:mx-2 xl:mx-0"
                            v-if="!shouldDelete"
                            @click="showModal"
                        >
                            <span
                                class="block text-[14px] text-white font-[CircularBook] tracking-wide">Create API Key</span>
                        </button>
                    </div>
                    <div class="px-[20px] pt-[20px]">
                        <div class="border border-[#eeeff2] rounded-[7px] p-6">
                            <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
                                <div class="flex flex-col sm:flex-row items-center sm:items-start gap-4">
                                    <div class="text-left">
                                        <div v-if="userProfileInfo.full_name"
                                             class="flex flex-col text-[22px] text-[#366fed] tracking-wide font-[CircularMedium] mb-1 items-center sm:items-start">
                                            <span>{{ userProfileInfo.full_name }}</span>
                                        </div>
                                        <div
                                            class="flex flex-col text-[18px] tracking-wide font-[CircularMedium] mb-3 items-center sm:items-start">
                                            <span>{{ user.email }}</span>
                                        </div>
                                        <div class="flex flex-col text-[12px] font-[CircularBook] text-[#a4a6aa]">
                                            <div class="flex items-center gap-1.5 justify-center sm:justify-start">
                                                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fill-rule="evenodd"
                                                          d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                                                          clip-rule="evenodd"/>
                                                </svg>
                                                User id: {{ userProfileInfo.id }}
                                            </div>
                                            <div class="flex items-center gap-1.5 justify-center sm:justify-start">
                                                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fill-rule="evenodd"
                                                          d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                                          clip-rule="evenodd"/>
                                                </svg>
                                                Member since {{ userProfileInfo.created_at }}
                                            </div>
                                            <div v-if="userProfileInfo.last_login_at"
                                                 class="flex items-center gap-1.5 justify-center sm:justify-start">
                                                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fill-rule="evenodd"
                                                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                                                          clip-rule="evenodd"/>
                                                </svg>
                                                Last login: {{ userProfileInfo.last_login_at }} from
                                                {{ userProfileInfo.last_login_ip }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="flex flex-col gap-3 items-center lg:items-end">

                                    <div v-if="userProfileInfo.kyb_status === 'APPROVED'"
                                         class="flex items-center gap-2 text-white px-2 py-[.35em] rounded-lg text-sm font-medium bg-[#58bd7d]">
                                        <svg class="w-4 h-4"
                                             fill="currentColor" viewBox="0 0 640 640">
                                            <path
                                                d="M530.8 134.1C545.1 144.5 548.3 164.5 537.9 178.8L281.9 530.8C276.4 538.4 267.9 543.1 258.5 543.9C249.1 544.7 240 541.2 233.4 534.6L105.4 406.6C92.9 394.1 92.9 373.8 105.4 361.3C117.9 348.8 138.2 348.8 150.7 361.3L252.2 462.8L486.2 141.1C496.6 126.8 516.6 123.6 530.9 134z"/>
                                        </svg>
                                        KYB {{ capitalize(userProfileInfo.kyb_status) }}
                                    </div>
                                    <div
                                        :class="{
                                            'bg-[#97969a]' : userProfileInfo.kyc_status === 'UNVERIFIED',
                                            'bg-[#d8b84f]' : userProfileInfo.kyc_status === 'PENDING',
                                            'bg-[#58bd7d]' : userProfileInfo.kyc_status === 'APPROVED',
                                            'bg-[#cf3d3d]' : userProfileInfo.kyc_status === 'DECLINED'
                                        }"
                                        class="flex items-center gap-2 text-white px-2 py-[.35em] rounded-lg text-sm font-medium"
                                    >
                                        <svg v-if="userProfileInfo.kyc_status === 'APPROVED'" class="w-4 h-4"
                                             fill="currentColor" viewBox="0 0 640 640">
                                            <path
                                                d="M530.8 134.1C545.1 144.5 548.3 164.5 537.9 178.8L281.9 530.8C276.4 538.4 267.9 543.1 258.5 543.9C249.1 544.7 240 541.2 233.4 534.6L105.4 406.6C92.9 394.1 92.9 373.8 105.4 361.3C117.9 348.8 138.2 348.8 150.7 361.3L252.2 462.8L486.2 141.1C496.6 126.8 516.6 123.6 530.9 134z"/>
                                        </svg>
                                        <svg v-if="userProfileInfo.kyc_status === 'PENDING'" class="w-4 h-4"
                                             fill="currentColor" viewBox="0 0 640 640">
                                            <path
                                                d="M128 88C128 74.7 138.7 64 152 64L488 64C501.3 64 512 74.7 512 88C512 101.3 501.3 112 488 112L480 112L480 131C480 171.3 464 210 435.5 238.5L354 320L435.5 401.5C464 430 480 468.7 480 509L480 528L488 528C501.3 528 512 538.7 512 552C512 565.3 501.3 576 488 576L152 576C138.7 576 128 565.3 128 552C128 538.7 138.7 528 152 528L160 528L160 509C160 468.7 176 430 204.5 401.5L286 320L204.5 238.5C176 210 160 171.3 160 131L160 112L152 112C138.7 112 128 101.3 128 88zM238.5 435.5C234.6 439.4 231 443.6 227.8 448L412.2 448C409 443.6 405.4 439.4 401.5 435.5L320 354L238.5 435.5zM208.8 496C208.3 500.3 208 504.6 208 509L208 528L432 528L432 509C432 504.6 431.7 500.3 431.2 496L208.8 496zM382.1 224L258 224L320.1 286.1L382.2 224zM421.8 176C428.4 162.1 432 146.7 432 131L432 112L208 112L208 131C208 146.7 211.6 162.1 218.2 176L421.7 176z"/>
                                        </svg>
                                        <svg v-if="userProfileInfo.kyc_status === 'UNVERIFIED'" class="w-4 h-4"
                                             fill="currentColor" viewBox="0 0 640 640">
                                            <path
                                                d="M320 64C334.7 64 348.2 72.1 355.2 85L571.2 485C577.9 497.4 577.6 512.4 570.4 524.5C563.2 536.6 550.1 544 536 544L104 544C89.9 544 76.8 536.6 69.6 524.5C62.4 512.4 62.1 497.4 68.8 485L284.8 85C291.8 72.1 305.3 64 320 64zM320 416C302.3 416 288 430.3 288 448C288 465.7 302.3 480 320 480C337.7 480 352 465.7 352 448C352 430.3 337.7 416 320 416zM320 224C301.8 224 287.3 239.5 288.6 257.7L296 361.7C296.9 374.2 307.4 384 319.9 384C332.5 384 342.9 374.3 343.8 361.7L351.2 257.7C352.5 239.5 338.1 224 319.8 224z"/>
                                        </svg>
                                        <svg v-if="userProfileInfo.kyc_status === 'DECLINED'" class="w-4 h-4"
                                             fill="currentColor" viewBox="0 0 640 640">
                                            <path
                                                d="M183.1 137.4C170.6 124.9 150.3 124.9 137.8 137.4C125.3 149.9 125.3 170.2 137.8 182.7L275.2 320L137.9 457.4C125.4 469.9 125.4 490.2 137.9 502.7C150.4 515.2 170.7 515.2 183.2 502.7L320.5 365.3L457.9 502.6C470.4 515.1 490.7 515.1 503.2 502.6C515.7 490.1 515.7 469.8 503.2 457.3L365.8 320L503.1 182.6C515.6 170.1 515.6 149.8 503.1 137.3C490.6 124.8 470.3 124.8 457.8 137.3L320.5 274.7L183.1 137.4z"/>
                                        </svg>


                                        KYC {{ capitalize(userProfileInfo.kyc_status) }}
                                    </div>
                                    <div
                                        :class="{
                                            'bg-[#58bd7d]' : userProfileInfo.two_factor_status === 'enabled',
                                            'bg-[#cf3d3d]' : userProfileInfo.two_factor_status === 'disabled'
                                        }"
                                        class="flex items-center gap-2 text-white px-2 py-[.35em] rounded-lg text-sm font-medium">


                                        <svg v-if="userProfileInfo.two_factor_status === 'enabled'" class="w-4 h-4"
                                             fill="currentColor" viewBox="0 0 640 640">
                                            <path
                                                d="M530.8 134.1C545.1 144.5 548.3 164.5 537.9 178.8L281.9 530.8C276.4 538.4 267.9 543.1 258.5 543.9C249.1 544.7 240 541.2 233.4 534.6L105.4 406.6C92.9 394.1 92.9 373.8 105.4 361.3C117.9 348.8 138.2 348.8 150.7 361.3L252.2 462.8L486.2 141.1C496.6 126.8 516.6 123.6 530.9 134z"/>
                                        </svg>
                                        <svg v-if="userProfileInfo.two_factor_status === 'disabled'" class="w-4 h-4"
                                             fill="currentColor" viewBox="0 0 640 640">
                                            <path
                                                d="M183.1 137.4C170.6 124.9 150.3 124.9 137.8 137.4C125.3 149.9 125.3 170.2 137.8 182.7L275.2 320L137.9 457.4C125.4 469.9 125.4 490.2 137.9 502.7C150.4 515.2 170.7 515.2 183.2 502.7L320.5 365.3L457.9 502.6C470.4 515.1 490.7 515.1 503.2 502.6C515.7 490.1 515.7 469.8 503.2 457.3L365.8 320L503.1 182.6C515.6 170.1 515.6 149.8 503.1 137.3C490.6 124.8 470.3 124.8 457.8 137.3L320.5 274.7L183.1 137.4z"/>
                                        </svg>
                                        2FA {{ capitalize(userProfileInfo.two_factor_status) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-3 gap-[15px] xl:gap-[26px] px-[20px] pt-[20px] mb-[20px]">
                        <a href="/account/kyc/index" class="border border-[#eeeff2] rounded-[7px] text-center px-2 pt-5 pb-4">
                            <img class="block mx-auto mb-2" src="@/../img/icons/list-check-square.svg" alt="key">
                            <span class="block text-[18px] tracking-wide font-[CircularMedium]">Informations</span>
                            <span class="block text-[14px] text-[#a4a6aa] font-[CircularBook] leading-[1.2]">Info required for authentication</span>
                        </a>
                        <a href="/account/password/change" class="border border-[#eeeff2] rounded-[7px] text-center px-2 pt-5 pb-4">
                            <img class="block mx-auto mb-2" src="@/../img/icons/lock-square.svg" alt="lock">
                            <span class="block text-[18px] tracking-wide font-[CircularMedium]">Password Change</span>
                            <span class="block text-[14px] text-[#a4a6aa] font-[CircularBook] leading-[1.2]">Click here to change your actual password</span>
                        </a>
                        <a href="/account/two-factor" class="border border-[#eeeff2] rounded-[7px] text-center px-2 pt-5 pb-4">
                            <img class="block mx-auto mb-2" src="@/../img/icons/shield-square.svg" alt="shield">
                            <span class="block text-[18px] tracking-wide font-[CircularMedium]">2FA Verification</span>
                            <span class="block text-[14px] text-[#a4a6aa] font-[CircularBook] leading-[1.2]">Turn 2Factor Authentication on or off</span>
                        </a>
                    </div>

                    <div
                        v-if="shouldDelete"
                        class="p-[20px]"
                    >
                        <div class="flex flex-col md:flex-row items-center gap-4">
                            <span class="block text-[18px] font-[CircularMedium] tracking-wide mb-2">API Keys</span>
                            <div class="space-y-[10px] flex-1 w-full">
                                <div class="flex-1 space-y-[14px]">
                                    <div class="flex">
                                        <span class="text-[12px] font-[CircularBook] tracking-wide inline-flex justify-center items-center px-2 border rounded-s-0 border-[#eeeff2] border-e-0 rounded-s-[5px]">
                                            API Key
                                        </span>
                                        <input
                                            type="text"
                                            class="text-[#2a395a] rounded-none bg-white border text-[12px] block flex-1 min-w-0 w-full border-[#eeeff2] px-1.5 py-1 placeholder:text-[12px] placeholder:text-[#a4a6aa] placeholder:font-[CircularBook]"
                                            :value="apiKey"
                                            readonly
                                        >
                                        <button
                                            class="w-[90px] sm:w-[142px] text-[12px] font-[CircularBook] tracking-wide inline-flex justify-center items-center px-2 text-[#366fed] border rounded-s-0 border-[#eeeff2] border-s-0 rounded-e-[5px]"
                                            @click="copyToClipboard(apiKey)"
                                        >
                                            Copy to clipboard
                                        </button>
                                    </div>
                                </div>
                                <div class="flex-1 space-y-[14px]">
                                    <div class="flex">
                                        <span class="text-[12px] font-[CircularBook] tracking-wide inline-flex justify-center items-center px-2 border rounded-s-0 border-[#eeeff2] border-e-0 rounded-s-[5px]">
                                            API Secret Key
                                        </span>
                                        <input
                                            type="text"
                                            class="text-[#2a395a] rounded-none bg-white border text-[12px] block flex-1 min-w-0 w-full border-[#eeeff2] px-1.5 py-1 placeholder:text-[12px] placeholder:text-[#a4a6aa] placeholder:font-[CircularBook]"
                                            :value="apiSecretKey"
                                            readonly
                                        >
                                        <button
                                            class="w-[90px] sm:w-[142px] text-[12px] font-[CircularBook] tracking-wide inline-flex justify-center items-center px-2 text-[#366fed] border rounded-s-0 border-[#eeeff2] border-s-0 rounded-e-[5px]"
                                            @click="copyToClipboard(apiSecretKey)"
                                        >
                                            Copy to clipboard
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <button
                                class="max-w-[150px] w-full flex items-center justify-center gap-3 bg-[#366fed] hover:bg-[#5282eb] rounded-[5px] px-2 py-[.35em] md:mx-2 xl:mx-0"
                                @click="showModal"
                            >
                                <span class="block text-[14px] text-white font-[CircularBook] tracking-wide">Delete API Key</span>
                            </button>
                        </div>
                    </div>

                </div>
                <LoginHistory activities={{activities}} />
            </div>
        </div>
    </div>



<!--    <div class="container mobile-padding account-page">-->
<!--        <div class="card card-padding">-->
<!--            <h2>Account Page</h2>-->
<!--            <div class="account-links">-->
<!--                <a href="/account/kyc/index">-->
<!--                    <img :src="loginSvg" alt="">-->
<!--                    <div class="desc-cnt">-->
<!--                        <p class="card-title">KYC</p>-->
<!--                        <p class="card-desc">Verify your identity</p>-->
<!--                    </div>-->
<!--                </a>-->
<!--                <a href="/account/password/index">-->
<!--                    <img :src="passwordLockSvg" alt="">-->
<!--                    <div class="desc-cnt">-->
<!--                        <p class="card-title">Password Change</p>-->
<!--                        <p class="card-desc">Click here to change your password</p>-->
<!--                    </div>-->
<!--                </a>-->
<!--                <a href="/account/two-factor">-->
<!--                    <img :src="authenticationSvg" alt="">-->
<!--                    <div class="desc-cnt">-->
<!--                        <p class="card-title">2FA Verification</p>-->
<!--                        <p class="card-desc">Click here to turn 2FA on and off</p>-->
<!--                    </div>-->
<!--                </a>-->
<!--                <a href="/logout">-->
<!--                    <img :src="logoutSvg" alt="">-->
<!--                    <div class="desc-cnt">-->
<!--                        <p class="card-title">Logout</p>-->
<!--                        <p class="card-desc">Click here for safe logout</p>-->
<!--                    </div>-->
<!--                </a>-->
<!--            </div>-->
<!--            <h2 class="api-title">API Keys</h2>-->
<!--            <div class="desc">Use the button below to create an api key. Do not share the Api key and Secret key with anyone.</div>-->
<!--            <button v-if="shouldDelete" class="btn api-generate" data-toggle="modal" data-target="#codeModal">Delete api key</button>-->
<!--            <button v-else class="btn api-generate" data-toggle="modal" data-target="#codeModal">Create api key</button>-->
<!--            <div id="api-keys-div">-->
<!--                <div v-if="shouldDelete" class="key-generate">-->
<!--                    <label>API Key</label>-->
<!--                    <div class="form-group">-->
<!--                        <input class="form-control" type="text" :placeholder="apiKey" readonly>-->
<!--                        <span @click="copyToClipboard(apiKey)">Copy to clipboard</span>-->
<!--                    </div>-->
<!--                    <label>API Secret Key</label>-->
<!--                    <div class="form-group">-->
<!--                        <input class="form-control" type="text" :placeholder="apiSecretKey" readonly>-->
<!--                        <span @click="copyToClipboard(apiSecretKey)">Copy to clipboard</span>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
<!--        <div class="table-container">-->
<!--            <div class="table-card">-->
<!--                <div class="card card-padding">-->
<!--                    <h3>Activity History (Last 30 days)</h3>-->
<!--                    <div class="card-body">-->
<!--                        <div class="table-responsive">-->
<!--                            <table class="table">-->
<!--                                <thead>-->
<!--                                <tr>-->
<!--                                    <th>Date</th>-->
<!--                                    <th>IP Address</th>-->
<!--                                    <th>Activity</th>-->
<!--                                </tr>-->
<!--                                </thead>-->
<!--                                <tbody>-->
<!--                                    <tr v-for="activity in activities">-->
<!--                                        <td>{{ computedTimezoneDate(activity.created_at) }}</td>-->
<!--                                        <td>{{ activity.causer_ip }}</td>-->
<!--                                        <td>{{ activity.description }}</td>-->
<!--                                    </tr>-->
<!--                                </tbody>-->
<!--                            </table>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <nav aria-label="Page navigation example">-->
<!--                        <ul class="pagination justify-content-end">-->
<!--                            <li class="page-item" :class="{ 'disabled': !prevLink }">-->
<!--                                <a class="page-link" href="#" @click.prevent="fetchActivity(prevLink)">Previous</a>-->
<!--                            </li>-->
<!--                            <li class="page-item" :class="{ 'disabled': !nextLink }">-->
<!--                                <a class="page-link" href="#" @click.prevent="fetchActivity(nextLink)">Next</a>-->
<!--                            </li>-->
<!--                        </ul>-->
<!--                    </nav>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
    <div class="modal fade" id="codeModal" tabindex="-1" role="dialog" aria-labelledby="codeModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div>
                    <div class="flex items-center justify-between p-[20px] border-b border-[#eeeff2]">
                        <div class="flex items-center gap-4">
                            <span
                                class="block text-[25px] font-[CircularBook] tracking-wide">Enter the email code sent</span>
                        </div>
                        <img src="@/../img/icons/close-gray.svg" class="cursor-pointer" data-dismiss="modal"
                             alt="close">
                    </div>
                    <div class="p-[20px]">
                        <div class="flex-1 space-y-[14px]">
                            <div class="flex">
                                <input type="text" v-model="code"
                                       class="text-[#2a395a] rounded-none rounded-s-[5px] bg-white border text-[12px] block flex-1 min-w-0 w-full text-sm border-[#eeeff2] px-1.5 py-1 placeholder:text-[12px] placeholder:text-[#a4a6aa] placeholder:font-[CircularBook]"
                                       placeholder="Enter code here...">
                                <button :disabled="sendAgainSeconds > 0" @click="sendCode"
                                        class="w-[90px] sm:w-[142px] text-[12px] font-[CircularBook] tracking-wide inline-flex justify-center items-center px-2 text-[#366fed] border rounded-s-0 border-[#eeeff2] border-s-0 rounded-e-[5px] uppercase">
                                    {{ sendAgainSeconds <= 0 ? 'send again' : `${sendAgainSeconds}s` }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div
                        class="flex flex-wrap border-t border-[#eeeff2] px-4 items-center justify-center gap-[14px] py-4">
                        <button @click="submitMailCode"
                                class="max-w-[183px] w-full flex items-center justify-center gap-3 bg-[#366fed] hover:bg-[#5282eb] rounded-[5px] px-2 py-[.35em] md:mx-2 xl:mx-0">
                            <img src="@/../img/icons/check-white.svg" alt="">
                            <span class="block text-[14px] text-white font-[CircularBook] tracking-wide">Save</span>
                        </button>
                        <button data-dismiss="modal"
                                class="max-w-[183px] w-full flex items-center justify-center gap-3.5 text-[14px] text-[#a4a6aa] font-[CircularBook] bg-white rounded-[5px] py-1.5 px-6 border border-[#eeeff2]">
                            <span class="block">Cancel</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import {onMounted, ref, watch} from "vue";
import axios from "axios";
import Swal from "sweetalert2";
import clipboardCopy from "clipboard-copy";
import moment from "moment";
import LoginHistory from "../components/Tables/LoginHistory.vue";

const activities = ref({})
const prevLink = ref()
const nextLink = ref()
const user = window.user
const userProfileInfo = window.userProfileInfo
const code = ref()
const apiSecretKey = ref(user.api_secret_key ?? null)
const apiKey = ref(user.api_key ?? null)
const shouldDelete = ref(apiSecretKey.value !== null && apiKey.value !== null)
const sendAgainSeconds = ref(0);
let countdownInterval = null;


const computedTimezoneDate = (date) => {
    return moment(date).format("YYYY-MM-DD HH:mm:ss")
}

onMounted(() => {
    fetchActivity()
})

watch(sendAgainSeconds, (newValue) => {
    if (countdownInterval) {
        clearInterval(countdownInterval)
        countdownInterval = null
    }

    if (newValue > 0) {
        countdownInterval = setInterval(() => {
            if (sendAgainSeconds.value > 0) {
                sendAgainSeconds.value--
            } else {
                clearInterval(countdownInterval)
                countdownInterval = null
            }
        }, 1000)
    }
})

const showModal = () => {
    code.value = '';
    sendAgainSeconds.value = 0;
    sendCode(false);
    $('#codeModal').modal('show')
}

const copyToClipboard = (text) => {
    clipboardCopy(text)
    toastIt("success", "Successfully copied to clipboard!")
}

const fetchActivity = (link = null) => {
    axios.get(link || "/account/activity").then(({ data: { data } }) => {
        activities.value = data.data
        prevLink.value = data.prev_page_url
        nextLink.value = data.next_page_url
    }).catch(({ response: {data} }) => {
        toastIt("error", "Error!")
    });
}

const Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})

const toastIt = (icon, message) => {
    Toast.fire({
        icon: icon,
        title: message
    })
}

const sendCode = (showFailToast = true) => {
    axios.get('/account/api-key/mail-code')
        .then(({data: {data: {icon, message}}}) => {
            toastIt(icon, message);
            sendAgainSeconds.value = 60;
        })
        .catch(({response: {data: {data: {icon, message}}}}) => {
            let messageNumbers = message.match(/\d+/g).map(Number);
            sendAgainSeconds.value = messageNumbers[0] || 60;
            if (showFailToast) {
                toastIt(icon, message);
            }
        });
}

const submitMailCode = () => {
    axios.post('/account/api-key/submit-code', {code: code.value, delete: shouldDelete.value}).then(({data: {data}}) => {
        toastIt(data.icon, data.message);
        $("#codeModal").modal('hide');

        apiKey.value = data.api_key ?? null
        apiSecretKey.value = data.api_secret_key ?? null
        shouldDelete.value = !shouldDelete.value
    }).catch(({ response: {data} }) => {
        toastIt(data.data.icon, data.data.message)
    });
}

const capitalize = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

</script>
